import store from '@/store';

export default class WhatsAppUnpauseEvent {
  constructor(body) {
    const { status } = store.state.channel.channels.whatsapp;
    const pauseName = body.body.reason;
    const channel = 'whatsapp';

    if (status == 'scheduled_pause')
      return store.dispatch('pause/revertStatusLeaveSchedulePause', {
        channel,
        channelName: 'WhatsApp',
        pauseName,
      });

    store.dispatch('pause/unpauseWhatsAppChannel');
  }
}
